// Small pieces shared by the order screens (M7, WP7.2).

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@enp/ui';
import { Link } from '@tanstack/react-router';
import { Fragment } from 'react';

/** "Orders › CO-SRV-00012 › Edit". */
export function OrdersBreadcrumb({
  trail = [],
  page,
}: {
  trail?: { label: string; orderId: string }[];
  page: string;
}) {
  return (
    <Breadcrumb>
      <BreadcrumbList>
        <BreadcrumbItem>
          <BreadcrumbLink asChild>
            <Link to="/orders">Orders</Link>
          </BreadcrumbLink>
        </BreadcrumbItem>
        {trail.map((t) => (
          <Fragment key={t.orderId}>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to="/orders/$orderId" params={{ orderId: t.orderId }}>
                  {t.label}
                </Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
          </Fragment>
        ))}
        <BreadcrumbSeparator />
        <BreadcrumbItem>
          <BreadcrumbPage>{page}</BreadcrumbPage>
        </BreadcrumbItem>
      </BreadcrumbList>
    </Breadcrumb>
  );
}
